import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { PictureInPictureContext } from "./PictureInPictureContext";
import { jsx as _jsx } from "react/jsx-runtime";
var PictureInPictureProvider = function PictureInPictureProvider(_ref) {
  var videoRef = _ref.videoRef,
    onPictureInPictureChange = _ref.onPictureInPictureChange,
    children = _ref.children;
  var pictureInPictureIsAvailable = useMemo(function () {
    return 'pictureInPictureEnabled' in document;
  }, []);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pictureInPictureIsActive = _useState2[0],
    setPictureInPictureIsActive = _useState2[1];

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var onPIPChange = function onPIPChange() {
      var pipIsActive = document.pictureInPictureElement === videoRef.current;
      setPictureInPictureIsActive(pipIsActive);
      if (onPictureInPictureChange) {
        onPictureInPictureChange(pipIsActive);
      }
    };
    var videoElement = videoRef.current;

    // Add listeners to video element
    if (videoElement) {
      videoElement.addEventListener('enterpictureinpicture', onPIPChange);
      videoElement.addEventListener('leavepictureinpicture', onPIPChange);
    }
    return function () {
      if (videoElement) {
        videoElement.removeEventListener('enterpictureinpicture', onPIPChange);
        videoElement.removeEventListener('leavepictureinpicture', onPIPChange);
      }
    };
    // We're ignoring the onPictureInPictureChange prop, assuming it doesn't change after the first render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoRef]);
  var togglePictureInPicture = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!videoRef.current) {
            _context.next = 15;
            break;
          }
          _context.prev = 1;
          if (!pictureInPictureIsActive) {
            _context.next = 8;
            break;
          }
          if (!document.exitPictureInPicture) {
            _context.next = 6;
            break;
          }
          _context.next = 6;
          return document.exitPictureInPicture();
        case 6:
          _context.next = 11;
          break;
        case 8:
          if (!videoRef.current.requestPictureInPicture) {
            _context.next = 11;
            break;
          }
          _context.next = 11;
          return videoRef.current.requestPictureInPicture();
        case 11:
          _context.next = 15;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](1);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 13]]);
  })), [videoRef, pictureInPictureIsActive]);
  var contextValue = useMemo(function () {
    return {
      pictureInPictureIsAvailable: pictureInPictureIsAvailable,
      pictureInPictureIsActive: pictureInPictureIsActive,
      togglePictureInPicture: togglePictureInPicture
    };
  }, [pictureInPictureIsAvailable, pictureInPictureIsActive, togglePictureInPicture]);
  return /*#__PURE__*/_jsx(PictureInPictureContext.Provider, {
    value: contextValue,
    children: children
  });
};
export default PictureInPictureProvider;